import { useEffect, useState } from 'react';

import { dissoc, pipe } from 'ramda';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useQueryParam, StringParam } from 'use-query-params';

import useValidationSchema from 'hooks/useValidationSchema';
import { setItinerariesItemDataAction } from 'store/itinerariesItem';
import { fetchSampleItinerariesItemThunk } from 'store/itinerariesItem/thunks';
import logger from 'utils/logger';

import { validationSchema, tourRequestValidationSchema } from './validationSchema';

const propcessCustomAppInitial = (formValues) => {
  if (!formValues.app) return dissoc('app', formValues);
  return formValues;
};

const processInitialTourRequestId = (formValues, { tourRequestId } = {}) => {
  if (!tourRequestId) return formValues;
  if (formValues.tourRequest) return formValues;

  return {
    ...formValues,
    tourRequest: { id: Number(tourRequestId) },
  };
};

export const prepareInitialValues = pipe(processInitialTourRequestId, propcessCustomAppInitial);

export function useGeneralInfo(isSample) {
  const dispatch = useDispatch();
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const schema = isSample ? validationSchema : tourRequestValidationSchema;
  const validate = useValidationSchema(schema);
  const [sampleId] = useQueryParam('sampleId', StringParam);
  const { itemType } = useParams();

  useEffect(() => {
    if (!sampleId) {
      return;
    }

    const fetchSampleData = async () => {
      setIsLoading(true);
      try {
        const sampleData = await dispatch(fetchSampleItinerariesItemThunk(sampleId, 'template'));
        dispatch(setItinerariesItemDataAction({ ...sampleData, type: itemType }));
      } catch (err) {
        logger.error(err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSampleData();
  }, [sampleId]);

  return {
    error,
    isLoading,
    validate,
  };
}
